/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Tone_SuccessInputs */

const cs_toast_tone_success = /** @type {(inputs: Toast_Tone_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěch`)
};

const en_toast_tone_success = /** @type {(inputs: Toast_Tone_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

/**
* | output |
* | --- |
* | "Success" |
*
* @param {Toast_Tone_SuccessInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const toast_tone_success = /** @type {((inputs?: Toast_Tone_SuccessInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Tone_SuccessInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_tone_success(inputs)
	return cs_toast_tone_success(inputs)
});